/**
 * @module
 * @exports init
 * @description The core dispatcher for the settings in javascript.
 *
 */

import address from './address';

/**
 * @function init
 * @description Initialize the settings functionality.
 *
 */
const init = () => {
	address();
};

export default init;
